import React from 'react'
import { Modal } from '@zambezi/sdk/modal'

const ConfirmLogoutModal = ({ className = '', open, onCancel, onConfirm }) => {
  return (
    <Modal
      className={`${className} ob-modal js-modal`}
      title="Log out"
      withBackdrop
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      renderFooter={(onConfirm, onCancel) => (
        <div className="zb-modal-card-foot-actions">
          <button
            className="js-confirm-action zb-button zb-button-primary zb-modal-action"
            onClick={onConfirm}
          >
            Yes, log out of the access store
          </button>
          <button
            className="zb-button-link zb-modal-action js-cancel-action"
            onClick={onCancel}
          >
            No, cancel
          </button>
        </div>
      )}
    >
      Are you sure you want to log out of the access store?
    </Modal>
  )
}

export default ConfirmLogoutModal
